/** Check if an object has any iterable properties; return false otherwise. Optionally allow inherited properties as well. */
export function objectEmpty(
  object: object | null,
  inherited: boolean = false
): boolean {
  if (object)
    for (const prop in object) {
      if (!inherited && !Object.prototype.hasOwnProperty.call(object, prop))
        continue;
      return false;
    }
  return true;
}
